import { createFileRoute } from "@tanstack/react-router";
import Auth from "@/pages/Auth";
import { SEO } from "@/config/seoConfig";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/auth/")({
  head: () => seoHead(SEO.auth),
  component: Auth,
});
